module.exports = __webpack_public_path__ + "static/media/m-dduckguck.d155b513.png";